"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConvexHitbox = void 0;
const hitbox_1 = require("@/simulator/hitbox");
const roundHitbox_1 = require("./roundHitbox");
class ConvexHitbox extends hitbox_1.Hitbox {
    constructor(width, height, anchor) {
        super(anchor);
        this.width = width;
        this.height = height;
    }
    test(obj) {
        const hitbox = obj.hitbox;
        if (this._isNextTestCancelled) {
            this._isNextTestCancelled = false;
            return;
        }
        if (hitbox instanceof ConvexHitbox) {
            if (this.anchor.x > hitbox.anchor.x - this.width &&
                this.anchor.x < hitbox.anchor.x + hitbox.width &&
                this.anchor.y > hitbox.anchor.y - this.height &&
                this.anchor.y < hitbox.anchor.y + hitbox.height) {
                this._onHit.fire({
                    obj,
                    overlayX: (this.anchor.x === hitbox.anchor.x
                        ? 0
                        : (this.anchor.x > hitbox.anchor.x
                            ? -(hitbox.width - this.anchor.x + hitbox.anchor.x)
                            : this.width - hitbox.anchor.x + this.anchor.x)),
                    overlayY: (this.anchor.y === hitbox.anchor.y
                        ? 0
                        : (this.anchor.y > hitbox.anchor.y
                            ? -(hitbox.height - this.anchor.y + hitbox.anchor.y)
                            : this.height - hitbox.anchor.y + this.anchor.y))
                });
            }
        }
        else if (hitbox instanceof roundHitbox_1.RoundHitbox) {
            const diameter = 2 * hitbox.radius;
            if (hitbox.anchor.x > this.anchor.x - diameter &&
                hitbox.anchor.x < this.anchor.x + this.width &&
                hitbox.anchor.y > this.anchor.y - diameter &&
                hitbox.anchor.y < this.anchor.y + this.height) {
                this._onHit.fire({
                    obj,
                    overlayX: (this.anchor.x === hitbox.anchor.x
                        ? 0
                        : (this.anchor.x > hitbox.anchor.x
                            ? -(diameter - this.anchor.x + hitbox.anchor.x)
                            : this.width - hitbox.anchor.x + this.anchor.x)),
                    overlayY: (this.anchor.y === hitbox.anchor.y
                        ? 0
                        : (this.anchor.y > hitbox.anchor.y
                            ? -(diameter - this.anchor.y + hitbox.anchor.y)
                            : this.height - hitbox.anchor.y + this.anchor.y))
                });
            }
        }
    }
    testWall(canvas) {
        if (this.anchor.y <= 0) {
            return "y";
        }
        else if (this.anchor.x <= 0 || this.anchor.x + this.width >= canvas.width) {
            return "x";
        }
        return null;
    }
}
exports.ConvexHitbox = ConvexHitbox;
